<div class="upcoming-onboarding-container">
  <div class="onboarding-header">
    <div class="header-container">
      <app-title-field [title]="'Upcoming Onboarding'" [iconUrl]="personCheckIcon" [showLink]="true"
        (click)="navigateToOnboarding()"></app-title-field>
    </div>

    <div class="dropdown-container">
      <app-dropdown class="emerald-dropdown dropdown-cls" [options]="monthOptions" [label]="'Select Month'"
        (dropdownChange)="onMonthSelect($event)" [displayKey]="'label'" [valueKey]="'value'"
        [(ngModel)]="selectedMonthValue"></app-dropdown>
    </div>
  </div>

  <div *ngIf="isLoading" class="card-loading-overlay">
    <div class="card-spinner">
      <div class="spinner"></div>
      <span class="loading-text">Loading...</span>
    </div>
  </div>

  <div *ngIf="!isLoading && onboardingData.length > 0; else noDataTemplate" class="datatable-container">
    <app-table [columnDefs]="UPCOMING_COLUMNS" [rowData]="onboardingData" [gridOptions]="gridOptions"
      [enableActions]="tableConfig.enableActions || false" [enablePagination]="tableConfig.enablePagination ?? true"
      [paginationPageSize]="tableConfig.paginationPageSize || 10"
      [enableRowSelection]="tableConfig.enableRowSelection || false"
      [rowSelectionMode]="tableConfig.rowSelectionMode || 'multiple'"
      [enableSorting]="tableConfig.enableSorting ?? true"
      [enableFiltering]="tableConfig.enableFiltering ?? true"
      [enableColumnResize]="tableConfig.enableColumnResize ?? true"
      [height]="maxTableHeight">
    </app-table>
  </div>

  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container>
          <h3 class="empty-state-title">{{ errorMsg }}</h3>
        </ng-container>
        <img
          [src]="imageSrc"
          alt="No records illustration"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>
</div>
